import React from 'react';
import CheckoutButton from './CheckoutButton';
import getThemeLookup from '../selectors/getThemeLookup';
import { useAppSelector } from '../app/hooks';
import combineStyles from '../utils/combineStyles';
import getDeviceTypeMobile from '../selectors/getDeviceTypeMobile';
import getExtremelyShortScreen from '../selectors/getExtremelyShortScreen';

interface IProps {
  checkoutSuccessful: (id?: string) => void;
  paymentStatusPolling?: boolean;
}

const PlaceOrderButton: React.FC<IProps> = ({ checkoutSuccessful, paymentStatusPolling }) => {
  const p = useAppSelector(getThemeLookup);
  const deviceTypeMobile = useAppSelector(getDeviceTypeMobile);
  const extremelyShortScreen = useAppSelector(getExtremelyShortScreen);
  const useMobileScreen = deviceTypeMobile || extremelyShortScreen;

  return (
    <div
      style={combineStyles(
        useMobileScreen ? styles.bottomBar : styles.bottomBarDesktop,
        p('reviewOrderBottomBar', ['backgroundColor']),
      )}
    >
      <CheckoutButton
        checkoutSuccessful={checkoutSuccessful}
        paymentStatusPolling={paymentStatusPolling}
        containerStyle={styles.buttonContainer}
      />
    </div>
  );
};

export default PlaceOrderButton;

const styles: Styles = {
  buttonContainer: {
    borderRadius: 5,
    width: '100%',
    maxWidth: 400,
    padding: '0.925em 1.25em',
    margin: 0,
  },
  bottomBar: {
    position: 'sticky',
    bottom: 0,
    width: '100%',
    backgroundColor: '#fff',
    display: 'flex',
    zIndex: 99,
    justifyContent: 'center',
    padding: '0.75em',
    minHeight: 80,
    height: 80,
  },
  bottomBarDesktop: {
    position: 'sticky',
    bottom: 0,
    width: '100%',
    backgroundColor: '#fff',
    zIndex: 99,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    maxWidth: 660,
    margin: '0px auto',
    padding: '0.75em',
    minHeight: 80,
    height: 80,
  },
};
